<div>
    <div><span class="fontHelvetica16">Confirma remoção</span></div>
    <div class="mt-16"><span class="fontDefault">Tem certeza que quer deletar definitivamente o anexo?</span></div>
    <div class="actions-buttons mt-16">
        <button mat-button class="btn-back" tabindex="-1" (click)="closeModal()">CANCELAR</button>
        <button mat-button class="btn-primary-ap" tabindex="-1" (click)="confirmar()">CONFIRMAR</button>
    </div>
</div>